module.exports = __webpack_public_path__ + "app-static/img/user.414506dc.jpg";